// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddToCartButton {
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: #22c55e;
  border: 1px solid #22c55e;
  border-radius: 0.5rem;
  transition: all 0.3s;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.AddToCartButtonText {
  color: #000000;
  font-weight: 600;
  padding: 10px 32px;
  transition: transform 0.3s;
  white-space: nowrap;
}

.AddToCartButton:hover .AddToCartButtonText {
  transform: translateX(-100%);
}

.AddToCartButtonIconContainer {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 40px;
  border-radius: 8px;
  background-color: #22c55e;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  transform: translateX(100%);
}

.AddToCartButton:hover .AddToCartButtonIconContainer {
  transform: translateX(0); /* Icon slides in on hover */
  width: 100%; /* Expand to fill button on hover */
}

.AddToCartButtonIconSVG {
  width: 24px;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AddToCartButton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB,EAAE,4BAA4B;EACtD,WAAW,EAAE,mCAAmC;AAClD;;AAEA;EACE,WAAW;EACX,cAAc;AAChB","sourcesContent":[".AddToCartButton {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background-color: #22c55e;\n  border: 1px solid #22c55e;\n  border-radius: 0.5rem;\n  transition: all 0.3s;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.AddToCartButtonText {\n  color: #000000;\n  font-weight: 600;\n  padding: 10px 32px;\n  transition: transform 0.3s;\n  white-space: nowrap;\n}\n\n.AddToCartButton:hover .AddToCartButtonText {\n  transform: translateX(-100%);\n}\n\n.AddToCartButtonIconContainer {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 40px;\n  border-radius: 8px;\n  background-color: #22c55e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s;\n  transform: translateX(100%);\n}\n\n.AddToCartButton:hover .AddToCartButtonIconContainer {\n  transform: translateX(0); /* Icon slides in on hover */\n  width: 100%; /* Expand to fill button on hover */\n}\n\n.AddToCartButtonIconSVG {\n  width: 24px;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
